import React, { useState, useEffect } from 'react';
import {
  PageHeader, Button,
} from 'antd';
import {
  ArrowLeftOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import ScheduleUpdateForm from './ScheduleUpdateForm';
import './ScheduleCreatePage.css';

function ScheduleModifyPage(props) {
  const { history, location } = props;
  const { state } = location;
  const [block, setBlock] = useState(0);
  const [scheduleId, setScheduleId] = useState(0);
  const [paramDateRange, setParamDateRange] = useState([]);
  let eventIndex = 0;
  if (state) eventIndex = state.eventIndex;

  const URL = useLocation();
  let propBlockId = 0;
  let propDateRange = [];
  if (URL) {
    if (URL.search) {
      const params = new URLSearchParams(URL.search);
      const blockId = params.get('blockId');
      const startDateParam = params.get('startDate');
      const endDateParam = startDateParam
        ? moment(startDateParam).add(12, 'hours')
        : null;
      if (startDateParam && endDateParam) {
        propDateRange = [moment(startDateParam), endDateParam];
      }
      if (blockId) {
        if (blockId.length > 0) propBlockId = Number(blockId);
      }
    }
  }
  useEffect(() => {
    if (URL) {
      if (URL.search) {
        const params = new URLSearchParams(URL.search);
        const blockId = params.get('blockId');
        const schId = params.get('scheduleId');
        const startDateParam = params.get('startDate');
        const endDateParam = startDateParam
          ? moment(startDateParam).add(12, 'hours')
          : null;
        if (startDateParam && endDateParam) {
          setParamDateRange([moment(startDateParam), endDateParam]);
        }
        if (blockId) setBlock(Number(blockId));
        if (schId) setScheduleId(Number(schId));
      }
    }
  }, [URL]);

  return (
    <div className="schedule-form-container">
      <div className="form-heading">
        <PageHeader
          title="Modify Irrigation Schedule"
          onBack={() => history.goBack()}
          backIcon={
            state && state.showBack
              ? (
                <Button className="back-form-button">
                  <ArrowLeftOutlined />
                  <span className="back-form-text">Go Back</span>
                </Button>
              ) : <div className="back-form-button"><span className="back-form-text" /></div>
            }
        />
        <div>&nbsp;</div>
      </div>
      <ScheduleUpdateForm
        blockId={block || propBlockId}
        scheduleId={scheduleId}
        eventIndex={eventIndex}
        dateRange={paramDateRange.length > 0 ? paramDateRange : propDateRange}
        onSubmit={() => history.goBack()}
      />
    </div>
  );
}

ScheduleModifyPage.propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func,
    push: PropTypes.func,
  }),
  location: PropTypes.shape({
    state: PropTypes.shape({
      showBack: PropTypes.bool,
      eventIndex: PropTypes.number,
    }),
  }),
};

ScheduleModifyPage.defaultProps = {
  history: {
    goBack: () => {},
    push: () => {},
  },
  location: {
    state: {
      showBack: false,
      eventIndex: 0,
    },
  },
};

export default ScheduleModifyPage;
